export const getQueryParamsObject = reactSearchParams => {
  const objectOfParams = {};
  for (const entry of reactSearchParams.entries()) {
    const [param, value] = entry;
    objectOfParams[param] = value;
  }
  return objectOfParams;
};
